import {content} from "./ko";

export const lang = {
    ...content,
};
